module.exports = __webpack_public_path__ + "img/soft.b73b908c.svg";